export const CONTRACT_SAVE = 'CONTRACT_SAVE';